// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"a7121dcf","494":"a7121dcf","725":"a7121dcf","858":"a7121dcf"}[chunkId] + ".chunk.css";
};